<ng-container *ngIf="data$ | async as data">
  <ng-container *ngIf="data.linkName">
    <cx-generic-link
      *ngIf="data.locUrl; else nonLocUrl"
      [target]="getTarget(data)"
      [class]="data.styleClasses ? data.styleClasses : ''"
      [url]="data.locUrl"
    >
      {{ data.linkName }}
    </cx-generic-link>
    <ng-template #nonLocUrl>
      <cx-generic-link [target]="getTarget(data)" [class]="data.styleClasses ? data.styleClasses : ''" [url]="data.url">
        {{ data.linkName }}
      </cx-generic-link>
    </ng-template>
  </ng-container>
</ng-container>
